import { patch } from 'incremental-dom';
import { pixLoadedObservable } from '../../pixList';
import { first } from 'rxjs/operators';
import { exportedSiteData } from '../../index';
import './imageBanner.scss';
// type bannerFunction = (any) => void;
// type bannerTitle = string | Node;
// interface BannerVariant {
//   variant: string;
//   media: string;
// };
// interface renderBannerParams {
//   imageName: string;
//   title: string | Node;
//   // variantArray?: Array<BannerVariant>
//   variantArray: Array<[string, number?]>
// };
// interface PageListItem {
//     pageLocation: string
//     content: any
//     image: bannerFunction | string | [string, bannerTitle] | renderBannerParams
//     pageTitle: string
//     subMenu?: ServiceLinkItem[]
//     name?: string
//     index?: boolean
//     hide?: boolean
// }
var ImageBanner = function (pageChangeObservable) {
    var ib = Object.create({});
    var bwel = document.createElement('div');
    bwel.setAttribute('id', 'bannerwrapper');
    var pw = document.getElementById('pagewrapper');
    pw.parentElement.insertBefore(bwel, pw);
    // FIXME: Auto install div
    pageChangeObservable.subscribe({
        next: function (ps) {
            var image = ps.image, pathVariables = ps.pathVariables;
            if (typeof image === 'string') {
                throw new Error('string imagebanner'); // deprecated
            }
            else if (typeof image === "function") {
                var el = document.getElementById('bannerwrapper'); // Assume can never be null
                patch(el, function () { return image(pageChangeObservable, pathVariables); });
                el.setAttribute('class', ps.name ? "functionbanner " + ps.name + "-banner" : 'functionbanner');
            }
            else {
                renderImageBanner(ps);
            }
        }
    });
    return ib;
};
var mediaString = function (min, max) {
    if (!min) {
        return "(max-width: " + (max - 1) + "px)";
    }
    if (!max) {
        return "(min-width: " + min + "px)";
    }
    return "(min-width: " + min + "px) and (max-width: " + max + "px)";
};
var renderImageBanner = function (ps) {
    var _a, _b;
    var imageName, title, variantArray;
    if (Array.isArray(ps.image)) {
        _a = ps.image, imageName = _a[0], title = _a[1];
        console.log('imageBanner.tsx: array image deprecated: ' + imageName);
    }
    else {
        (_b = ps.image, imageName = _b.imageName, title = _b.title, variantArray = _b.variantArray);
    }
    // variantArray: [
    //   {variant: 'mobile', media: '(max-width: 549px)'},
    //   {variant: 'wide', media: '(min-width: 550px) and (max-width: 1199px)'},
    //   {variant: 'pano', media: '(min-width: 1200px)'}
    // ]
    variantArray = variantArray || [['mobile', 550], ['wide', 1200], ['pano']];
    variantArray = variantArray.reduce(function (a, c) {
        a[0].push({ variant: c[0], media: mediaString(a[1], c[1]) });
        return ([a[0], c[1]]);
    }, [[], undefined])[0];
    // performance.mark('rawouter-start');
    // The bannerwrapper div is added to every page in the markup
    // If imageName is '' remove the banner contents and class attributes but leave the div
    if (imageName.length === 0) {
        var elm = document.getElementById('bannerwrapper'); // Assume can never be null
        while (elm.hasChildNodes()) {
            elm.removeChild(elm.lastChild);
        }
        if (elm.hasAttribute('class')) {
            elm.removeAttribute('class');
        }
        return;
    }
    var multiPix = function (ap4, pel) {
        if (ap4.length > 0) {
            var defaultPix = ap4.filter(function (p) { return ((p.file === imageName) && (p.variant === 'wide')); })[0];
            var defaultSize = defaultPix.sizes.sort(function (a, b) { return (Math.pow((a - 1024), 2) < Math.pow((b - 1024), 2)) ? -1 : +1; })[0]; // The size closest to 1024
            // console.log(imageArray)
            variantArray.map(function (_a, i) {
                var variant = _a.variant, media = _a.media;
                var mobilePixArray = ap4.filter(function (p) { return ((p.file === imageName) && (p.variant === variant)); });
                if (mobilePixArray.length > 0) {
                    var mobilePix = mobilePixArray[0];
                    var imageBase_1 = "" + exportedSiteData.assetBase + mobilePix.pathprefix + "/" + [mobilePix.file, mobilePix.variant, mobilePix.hash].filter(function (p) { return p; }).join('-');
                    var webpSrc = mobilePix.sizes.map(function (s) { return imageBase_1 + "-" + s + ".webp " + s + "w"; }).join();
                    var jpgSrc = mobilePix.sizes.map(function (s) { return imageBase_1 + "-" + s + ".jpg " + s + "w"; }).join();
                    var ps_1 = document.createElement('source');
                    ps_1.setAttribute('type', 'image/webp');
                    ps_1.setAttribute('srcset', webpSrc);
                    ps_1.setAttribute('media', media);
                    pel.appendChild(ps_1);
                    var psj = document.createElement('source');
                    psj.setAttribute('type', 'image/jpeg');
                    psj.setAttribute('srcset', jpgSrc);
                    psj.setAttribute('media', media);
                    pel.appendChild(psj);
                }
            });
            var im = document.createElement('img');
            im.setAttribute('src', "" + exportedSiteData.assetBase + defaultPix.pathprefix + "/" + [defaultPix.file, defaultPix.variant, defaultPix.hash, defaultSize].join('-') + ".jpg");
            pel.appendChild(im);
        }
        else {
            // performance.mark('ww-start');
            var w = window.innerWidth;
            var h = w < 550 ? 0.667 : w < 1024 ? 0.333 : 0.25;
            var im = document.createElement('img');
            var svginline = "data:image/svg+xml;utf8,<svg  xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 680 " + 680 * h + "\"><rect width=\"680\" height=\"" + 680 * h + "\"  style=\"fill:%23eee\" /></svg>";
            im.setAttribute('src', svginline);
            pel.appendChild(im);
            // performance.mark('ww-end');
            // performance.measure('wwMarker', 'ww-start', 'ww-end');
        }
    };
    var createPictureFragment = function (ap3) {
        var fragment = document.createDocumentFragment();
        var pel = document.createElement('picture');
        pel.setAttribute('id', 'multi-aspect-pix');
        multiPix(ap3, pel);
        fragment.appendChild(pel);
        return fragment;
    };
    var createTitleFragment = function (title) {
        if (title === undefined) {
            var twrap = document.createElement('div');
            return twrap;
        }
        ;
        if (typeof title === 'function') {
            var twrap = document.createElement('div');
            twrap.setAttribute('class', 'hero-image-title');
            patch(twrap, function () { return title(); });
            return twrap;
        }
        else if (typeof title === 'string') {
            var twrap = document.createElement('div');
            twrap.setAttribute('class', 'hero-image-title');
            var hel = document.createElement('h2');
            hel.setAttribute('class', 'hero-image-text hero-image-text-gradient');
            var tel = document.createElement('text');
            hel.textContent = title;
            twrap.appendChild(hel);
            return twrap;
        }
        return title;
    };
    var el = document.getElementById('bannerwrapper'); // Assume can never be null
    if (el === null) {
        throw new Error('utils.ts: No bannerwrapper'); // FIXME: Send message to error logger without throwing
    }
    var className = el.getAttribute('class');
    if (className !== 'photobanner') {
        while (el.hasChildNodes()) {
            el.removeChild(el.lastChild);
        }
        var fragment = createPictureFragment([]); // Create data_svg placeholder
        el.appendChild(fragment);
        el.appendChild(createTitleFragment(title));
    }
    el.setAttribute('class', ps.name ? "photobanner " + ps.name + "-banner" : 'photobanner');
    // if (typeof title === 'string') {
    (el).replaceChild(createTitleFragment(title), (el).childNodes[1]);
    // } else {
    //     console.log('appending title2');
    //     console.log((el).childNodes[1]);
    //     (el).replaceChild(title, (el).childNodes[1]);
    // }
    // (el).replaceChild(createTitleFragment(title), (el).childNodes[1]);
    // Replace the image once the pixlist is available
    pixLoadedObservable
        .pipe(
    // FIXME: Type is Array<SitePix>
    first(function (a) { return a.length > 0; }))
        .subscribe(function (ap) {
        var fragment = createPictureFragment(ap);
        (el).replaceChild(fragment, (el).firstChild);
    });
};
export { ImageBanner };
//# sourceMappingURL=imageBanner.js.map